module.exports = __webpack_public_path__ + "img/pic_map_shopMengZheng.71b42733.png";